var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup30484(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30484",
    "data-name": "Group 30484",
    transform: "translate(-1099 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(1099 68)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10.5,
    ry: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10,
    ry: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    transform: "translate(1099 62)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10.5,
    ry: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10,
    ry: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    transform: "translate(1099 73)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10.5,
    ry: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 4.5,
    rx: 10,
    ry: 4,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30484);
export default __webpack_public_path__ + "static/media/group-30484.e805f26709e3f5deeb7af7691b01aefd.svg";
export { ForwardRef as ReactComponent };